import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { IAirport, IEditRowField, IOperation, IOperationListColumnResponse } from './airport-interfaces';
import { AirportService } from './airport.service';
import { QueryReportService } from '../query-reports/query-report.service';
import { IQueryReportResponse, IQueryReportRequest } from '../query-reports/query-report';
import { IScenario, ScenarioService } from '../scenario-activities/scenario.service';
import { UserSession } from '../shared/user-session';
import { UserInfoService } from '../shared/user-info.service';
import { DmsToDecimalPipe } from './dms-to-degrees.pipe';
import { DialogModule } from 'primeng/primeng';
import { Dialog } from 'primeng/primeng';
import { Button } from 'primeng/primeng';
import { Messages } from 'primeng/primeng';
import { Column } from 'primeng/primeng';
import { TemplateLoader } from 'primeng/primeng';
import { TemplateWrapper } from 'primeng/primeng';
import { PrimeTemplate } from 'primeng/primeng';
import { ColumnBodyTemplateLoader } from 'primeng/primeng';
import { Footer } from 'primeng/primeng';
import * as _ from 'lodash';
import { IRegionalREview } from '../system-management/regional-review/regional-review';
import { SystemControlElem } from '../shared/system-control-elem';
import { SystemControlService } from '../shared/system-control.service';
import { Http, Response, RequestOptionsArgs, Headers } from '@angular/http';
import { AuthService } from '../authentication/auth.service';
import { Json } from '@angular/core/src/facade/lang';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';

declare var TableToExcel: any;
declare var URL: any;

//import * as XLSX from 'xlsx';
//import * as FileSaver from 'file-saver';4371478

export enum ReviewStatus{
    NotStartedOpen = 0,
    DraftOpen = 1,
    SubmittedOpen = 2,
    SubmittedClosed = 3,
    DraftClosed = 4,
    NeverStartedClosed =5
}
@Component({
    //templateUrl: 'app/airports/airport.component.html',
    template: require('./regional-review.component.html'),
    styles: [require('../styles/faa_styles.css'), require('../styles/print_faa_styles.css')],
    directives: [ROUTER_DIRECTIVES, Dialog, Button, Messages, Column, TemplateLoader, TemplateWrapper, PrimeTemplate, ColumnBodyTemplateLoader, Footer],
    pipes: [DmsToDecimalPipe],
    selector: 'app-collapse-expand',
})

export class RegionalReviewComponent implements OnInit, OnDestroy {
    pageTitle: string = 'Regional Review ';
    mainFileTypes = ['.xls', '.xlsx'];
    attachmentTypes = ['.png', '.jpg', '.jpeg', '.doc', '.docx', '.xls', '.xlsx', '.pdf'];
    errorMessage: string;
    airport: IAirport;
    private sub: any;
    currentScenario: IScenario;
    allScenarios: IScenario[];
    scenarioHeaderDiv: HTMLDivElement;
    accessDenied: boolean = false;
    //tableTitleDiv: HTMLDivElement;
    tableTitle: string;
    displayNotes: boolean = false;
    scenarioNote: string;
    review: any;
    attachments: any;
    reviewStatus: number;
    reviewcommentId: number = 0;
    reviewFile: File;
    reviewComment: string;
    reviewSubmitDate: string;
    originalComment: string;
    reviewAttachments: File[] = [];
    originalAttachments: any;
    endRegionalPeriod: string;
    notesTitle: string;
    facListTitle: string;
    graphDataTitle: string;

    isScenarioOwner: boolean = false;
    isReadOnly: boolean = false;
    canEdit: boolean = false;
    nextFacility: string;
    previousFacility: string;
    operations: IOperation[];
    facList: IAirport[];
    displayFacilityList: boolean = false;
    cols: any[];
    displaySpinner: boolean = false;
    request: IQueryReportRequest;
    facReportListResponse: IQueryReportResponse[];
    msgs: Messages[] = [];
    msgsAll: Messages[] = [];
    displayGraphData: boolean = false;
    showAll: string = "true";
    isCollapsed = true;
    isDragOver: boolean = false;
    viewOnly: boolean = false;
    displayConfirmDialog: boolean = false;
    displayRevertDialog: boolean = false;
    maxChars: number = 2000;
    fileToDelete: any = null;
    idsToDelete: number[] = [];
    displayDeleteDialog: boolean = false;
    displayAlertDialog: boolean = false;
    alertDialog: string;
    isSaveClicked: boolean = false;

    dialogHeader = "Upload Your Regional Comments";
    editRow: any[];
    editData: any[];
    displayDialog: boolean = false;
    editableColumns: IOperationListColumnResponse[];
    systemControlElem: SystemControlElem;
 
    blobUrls: string[] =[];
    results: any[];
    locIdFromRoute: any = null;
    constructor(private route: ActivatedRoute,
        private router: Router,
        private http: Http,
        private _airportService: AirportService,
        private _scenarioService: ScenarioService,
        private User: UserSession,
        private _userInfoService: UserInfoService,
        private _queryReport: QueryReportService,
        private authService: AuthService,
        private _systemControlService: SystemControlService) {
    }

    @ViewChild('scenarioHeader') scenarioHeader: ElementRef;
    @ViewChild('reviewFileInput') reviewFileInput: ElementRef;
    @ViewChild('reviewAttachmentsInput') reviewAttachmentsInput: ElementRef;
    //@ViewChild('tableTitle') tableTitle: ElementRef;

    ngOnInit(): void {
        this.isReadOnly = this.authService.isReadOnly();
        this.scenarioHeaderDiv = this.scenarioHeader.nativeElement;
            
        this.sub = this.route.params.switchMap(
            params => {
                let id = params['locId'];
                console.warn("Attempting to load Airport: " + id + " using ScenarioID: " + this.User.getSession().scenarioId);
                this.locIdFromRoute = !_.isEmpty(id) ? id: null;
                return this._scenarioService.getRegionalReviewScenarios(this.User.getSession()['id']);
            })
            .subscribe(
                scenarios => {
                    this.allScenarios = scenarios;
                    this.setScenarioHeader(this.User.getSession().scenarioId);
                    // //this probably needs to be somewhere more central
                    this.User.updateSessionState();

                    if (this.locIdFromRoute)
                    {
                        this.getAirport(this.locIdFromRoute);
                    }
                    else
                    {
                        this.getAirportFromScenario();
                    }
                    this._userInfoService.isScenarioOwner(this.User.getSession()['id'], this.User.getSession().scenarioId).subscribe(
                        success => {
                            this.isScenarioOwner = success.isOwner;
                            console.log("is scenario owner = " + this.isScenarioOwner + ".. " + this.User.getSession().scenarioId + " ...  " + this.User.getSession()['id']);
                            this._systemControlService.getSystemControl()
                                .subscribe(
                                    systemControlElem => {
                                        this.systemControlElem = systemControlElem;
                                        this.getRegionalReivewSummary();
                                        this.getRegionalReivew();
                                    },
                                    error => this.errorMessage = <any>error
                                );
                            if(this.isReadOnly){
                                //console.log("this.isScenarioOwner == false " + (this.isScenarioOwner == false));
                                this.showAll = "false";
                                this.msgsAll = [];
                                this.msgsAll.push({severity:'warn', summary:'Warn Message', detail:'We\'re sorry,  your access level does not permit you to view this page. Contact the TAF administrator to change your access privileges.'});
                            }
                        },
                        error => this.errorMessage = <any>error
                    );
                },
                error => this.errorMessage = <any>error


        );
        
    }

    ngOnDestroy() {
        this.blobUrls.forEach(u => URL.revokeObjectURL(u));
        this.sub.unsubscribe();
    }

    toggleContent() {
        this.isCollapsed = !this.isCollapsed;
    }

    getRegionalReivew() {

        if (!this.isReadOnly) {
            //default review value 
            this.reviewStatus = ReviewStatus.NotStartedOpen;
            this.reviewComment = "";
            this.originalComment = "";
            this.reviewAttachments = [];
            this.reviewFile = null;
            this.review = {};
            this.attachments = [];
            this.originalAttachments = [];
            let today: Date = new Date();
            let reviewEndDate = new Date(this.systemControlElem.reviewEndDate as any);

            //console.log(this.isScenarioOwner + " -- currentScenario -- " + Json.stringify(this.currentScenario));
            //if (this.isScenarioOwner ) {
                this._airportService.getRegionalReview(this.User.getSession().scenarioId, this.User.getSession()['id'])
                    .subscribe(
                        results => {
                            this.reviewcommentId = 0;
        
                            if (results.commentId > 0) {
                                this.review = results;
                                this.viewOnly = false;
                                this.reviewComment = results.reviewComment;
                                this.reviewcommentId = results.commentId;
                                this.originalComment = results.reviewComment;
                                this.attachments = this.review.attachments;
                                this.reviewSubmitDate = results.submitDate;
                                this.originalAttachments = JSON.parse(JSON.stringify(this.review.attachments || []));

                                if (this.reviewSubmitDate) {
                                    this.reviewStatus = ReviewStatus.SubmittedOpen; // Submitted, open

                                    //check if review period close. 
                                    if (reviewEndDate <= today) {
                                        this.reviewStatus = ReviewStatus.SubmittedClosed; // Submitted, closed
                                    }
                                }
                                else {
                                    if (today <= reviewEndDate) {
                                        this.reviewStatus = ReviewStatus.DraftOpen; // Draft, open
                                    } else {
                                        this.reviewStatus = ReviewStatus.DraftClosed; // Draft, closed
                                    }

                                }
                            }
                            else {
                                if (today > reviewEndDate) {
                                    this.reviewStatus = ReviewStatus.NeverStartedClosed; // Never started, closed
                                } else {
                                    this.reviewStatus = ReviewStatus.NotStartedOpen; // Not started, open
                                }
                            }
                        },
                        error => this.errorMessage = <any>error
                    );
            //}
        }
    }


    getRegionalReivewSummary() {
        //start year is FyYear -2
        this._airportService.getRegionalReviewSummary(this.User.getSession().scenarioId)
            .subscribe(
                results => {
                    this.results = results;
                    this.results.map(result => {
                        result.ffcYearDisplay = result.scenarioYear == "" ? result.FyYear : result.FyYear + result.scenarioYear;
                    });
                },
                error => this.errorMessage = <any>error
            );
    }

    getOperations() {
        this._airportService.getOperations()
            .subscribe(
                operations => this.operations = operations,
                error => this.errorMessage = <any>error);
    }

    getAirportFromScenario() {
        let idUsed = this.User.getSession().scenarioId;
        // console.warn("REPRO STEP 1: Asking for default airport using Stale ID:", idUsed);
        this._airportService.getAirportFromScenario(idUsed)
            .subscribe(
                success => {
                    // console.warn("REPRO STEP 2: Got default airport: " + success);
                    // console.warn("REPRO STEP 3: Pausing for 2 seconds to let the Session Update finish...");
                    // DEBUGGING: This guarantees 'getRegionalReviewScenarios' finishes and runs 'updateSessionState()'
                    // setTimeout(() => {
                    let newId = this.User.getSession().scenarioId;
                    // console.warn("REPRO STEP 4: Resume! Current Session ID is now:", newId);

                    if (idUsed !== newId) {
                        // console.error("BOOM! We have a mismatch! Loading Airport from ID " + idUsed + " into Scenario " + newId);
                        return;
                    }

                        this.getAirport(success);
                    // }, 2000);
                    // ---------------------
                },
                error => this.errorMessage = <any>error 
            )
    }

    getAirport(locId: string) {
        this._airportService.getAirport(locId, this.User.getSession().scenarioId)
            .subscribe(
                airport => this.airport = airport,
                error => this.errorMessage = <any>error,
                () => {
                    if (this.airport.locId == undefined) {
                        this.accessDenied = true;
                        this.showAll = "false";
                    }
                    else {
                        this.msgsAll = [];
                        this.showAll = "true";
                        this.setCanEdit();
                        //this.setNextAndPrevious(locId);
                    }
                });
    }

    setCanEdit() {
        this.canEdit = false;
        this._userInfoService.getRegCode(this.User.getSession()['id'])
            .subscribe(
                success => {
                    if (this.User.getSession().isAdmin || (this.User.getSession().isRegionalManager && success === this.airport.region)) {
                        this.canEdit = true;
                    }
                }
            );
    }

    onScenarioChange(event: Event): void {
        let selectedScenarioId: number = +(event.target as HTMLSelectElement).value;
        this.User.scenarioId = selectedScenarioId;
        this.User.updateSessionState();
        this.setScenarioHeader(selectedScenarioId);

        this._userInfoService.isScenarioOwner(this.User.getSession()['id'], this.User.getSession().scenarioId).subscribe(
            success => {
                this.isScenarioOwner = success.isOwner;
                this.getRegionalReivew();
            },
            error => this.errorMessage = <any>error
        );

        this.getAirportFromScenario();
        this.getRegionalReivewSummary();
    }

    private setScenarioHeader(scenarioId: number): void {
        let foundScenarios: IScenario[] = this.allScenarios.filter(function (scenario) {
            return scenario.id === scenarioId;
        });
        if (foundScenarios.length > 0) {
            this.currentScenario = foundScenarios[0];        
        } else if (this.allScenarios.length > 0) {
            this.currentScenario = this.allScenarios[0];
        }
        if (this.currentScenario.id != this.User.scenarioId) {
            this.User.scenarioId = this.currentScenario.id;
            this.User.updateSessionState();
        }
        this.scenarioHeaderDiv.innerHTML = `<strong>Current Scenario: ${this.currentScenario.scenarioName} (${this.currentScenario.id})</strong>`;
        this.tableTitle = `For ${this.currentScenario.scenarioName} -- Scenario`; // ${this.systemControlElem.fyYear}
        // if (!!this.tableTitle?.nativeElement) {
        //     this.tableTitleDiv.innerHTML = `For ${this.currentScenario.scenarioName} -- Scenario`; // ${this.systemControlElem.fyYear}
        // }            
    }

    ExportExcel() {
        const table = document.getElementById("datasummary");

        // Format date as YYYYMMDD
        const now = new Date();
        const year = now.getFullYear();
        const month = ('0' + (now.getMonth() + 1)).slice(-2);
        const day = ('0' + now.getDate()).slice(-2);
        const dateStr = `${year}${month}${day}`;

        TableToExcel.convert(table, {
            
            name: "RegionalReviewReport_" + this.airport.locId + "_" + dateStr  +".xlsx",
            sheet: { name: "Sheet 1" }
        });


    }

    // private saveAsExcelFile(buffer: any, fileName: string): void {
    //     const data: Blob = new Blob([buffer], {
    //         type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    //     });
    //     FileSaver.saveAs(data, `${fileName}_${new Date().getTime()}.xlsx`);
    // }

    ImportExcel() {
        this.viewOnly = false;
        this.dialogHeader = "Upload Your Regional Comments";
        this.displayDialog = true;


    }
    openViewSubmission(): void {
        this.viewOnly = true;
        this.dialogHeader = "View Your Regional Comments";
        this.displayDialog = true;
    }

    submitReview(): void {
        this.displaySpinner = true;
        //console.log("Confirm submit = " + this.reviewcommentId);
        if (this.reviewcommentId) {

            var params = {
                Commentid: this.reviewcommentId,
                Locid: this.airport.locId,
                AirportName: this.airport.name
            };
            this._airportService.submitRegionalReviewFile(params)
                .subscribe(
                    success => {
                        //console.log("submit review = " + success.responseStatus + ": " + success.responseMessage);
                        if (success.responseStatus == "success") {
                            let today: Date = new Date();
                            this.reviewSubmitDate = today.toString();
                            this.reviewStatus = ReviewStatus.SubmittedOpen;                           
                            this.displayConfirmDialog = false;
                            this.displaySpinner = false;
                            if (success.responseMessage != ""){
                                this.alertDialog = success.responseMessage;
                                this.displayAlertDialog = true; 
                            }
                        }
                    },
                    error =>{
                        this.errorMessage = <any>error;
                        this.displayConfirmDialog = false;
                        this.displaySpinner = false;
                       
                    }               
                );
        } else {
            this.errorMessage = "An error occured while attempting to submit your comment. No record found. ";
        }
    }

    readfile(infile: File) {
        const reader = new FileReader();
        reader.readAsArrayBuffer(infile);
    }

    onFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            if (!this.isAllowedFile(input.files[0], this.mainFileTypes)) {
                this.displayAlertDialog = true;
                this.alertDialog = "Invalid file type. Only .xls or .xlsx files are allowed for the main file.";
                return;
            }

            this.reviewFile = this.processFilesForUpload([input.files[0]])[0];
            console.log(`Selected review file: ${this.reviewFile.name}`);

            const newFileEntry = {
                file: this.reviewFile,
                fileUrl: null,
                fileName: this.reviewFile.name,
                isAttachment: false
            };

            // Ensure attachments is never null
            const currentAttachments = this.attachments || [];

            // Keep only "attachments", replace main file
            this.attachments = [
                ...currentAttachments.filter(x => x.isAttachment),
                newFileEntry
            ];
        }
        this.resetFileInputs();
    }

    onAttachmentSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (input.files) {
            const selectedFiles = Array.from(input.files);
            const validFiles: File[] = [];
            const invalidFiles: File[] = []; 
            const duplicatedFiles: File[] = []; 
            const existingNames = new Set((this.attachments || []).filter(a => a.isAttachment).map((a: { fileName: string }) => this.reverseFileName(a.fileName)));
            selectedFiles.forEach(file => {
                if (!this.isAllowedFile(file, this.attachmentTypes)) {
                    invalidFiles.push(file);
                } 
                else if (existingNames.has(file.name))
                {
                    duplicatedFiles.push(file);
                }
                else {
                    validFiles.push(file);
                }
            });

            if (invalidFiles.length > 0 || duplicatedFiles.length > 0) {
                const messages: string[] = [];
                if (invalidFiles.length > 0)
                {
                    messages.push(`The following ${invalidFiles.length} file(s) have an invalid type and cannot be uploaded: ${invalidFiles.map(f => f.name).join(', ')}.\n
                                    Allowed types: ${this.attachmentTypes.join(', ')}`)
                }
                if (duplicatedFiles.length > 0)
                {
                    messages.push(`The following ${duplicatedFiles.length} file(s) are already attached and will not be uploaded again: ${duplicatedFiles.map(f => f.name).join(', ')}.\n`)
                }
                this.displayAlertDialog = true;
                this.alertDialog = messages.join('\n\n');
            }
            const processedFiles = this.processFilesForUpload(validFiles);
            this.reviewAttachments = [...(this.reviewAttachments || []), ...processedFiles];
            // console.log('Exisiting attachments:', this.attachments);

            const newAttachments = processedFiles.map(file => ({
                file: file,
                fileUrl: null,
                fileName: file.name,
                isAttachment: true
            }));
            this.attachments = [...(this.attachments || []), ...newAttachments];
        }
        this.resetFileInputs();
    }

    ontextChange(event: Event): void {
        const input = event.target as HTMLInputElement;
        this.reviewComment = input.value;
    }

    save() {
        // Validation
        const hasMainFile = this.attachments && this.attachments.some(a => !a.isAttachment);
        const hasAttachments = this.attachments && this.attachments.some(a => a.isAttachment);
        const hasComment = this.reviewComment && this.reviewComment.trim().length > 0;

        this.isSaveClicked = true;

        if (!hasMainFile || !hasAttachments || !hasComment) {
            this.errorMessage = "File, at least one attachment, and comment are required.";
            return;
        }

        const formData = new FormData();
        formData.append('ReviewFile', this.reviewFile);

        // Check the Excel File
        this._airportService.checkRegionalReviewFile(formData).subscribe(
            success => {
                this.displaySpinner = true;

                // Prepare the FormData for the final save
                formData.append('ScenarioId', this.User.getSession().scenarioId.toString());
                formData.append('LocId', this.airport.locId);
                formData.append('UserId', this.User.getSession()['id'].toString());
                formData.append('CommentId', this.reviewcommentId.toString());
                formData.append('ReviewComment', this.reviewComment);

                if (this.reviewAttachments) {
                    for (let i = 0; i < this.reviewAttachments.length; i++) {
                        formData.append('ReviewAttachments', this.reviewAttachments[i]);
                    }
                }

                // Pending deletion
                if (this.idsToDelete.length > 0) {

                    // Create a list of API calls
                    let tasks = this.idsToDelete.map(id => {
                        return this._airportService.deleteRegionalReviewFile({ id: id });
                    });

                    // Run them all in parallel
                    Observable.forkJoin(tasks).subscribe(
                        results => {
                            this.executeFinalSave(formData);
                        },
                        error => {
                            this.displaySpinner = false;
                            this.errorMessage = "Failed to delete old files. Save cancelled.";
                        }
                    );

                } else {
                    // Final save after delete are done
                    this.executeFinalSave(formData);
                }
            },
            error => {
                this.isSaveClicked = false;
                this.displaySpinner = false;

                // Browser-level failure 
                if (error instanceof ProgressEvent) {
                    this.alertDialog =
                        'The upload could not be completed.\n\n' +
                        'If you modified the file after selecting it, please re-select it. Otherwise, check your network connection and try again.';
                    this.displayAlertDialog = true;
                    return;
                } 

                // Backend error
                if (error) {
                    this.alertDialog = error;
                    this.displayAlertDialog = true;
                    return;
                }

                // fallback
                this.alertDialog = 'An unexpected error occurred.';
                this.displayAlertDialog = true;
            } 
        );
    }

    // Helper function to avoid code duplication
    executeFinalSave(formData: any) {
        this._airportService.saveRegionalReview(formData).subscribe(
            success => {
                this.idsToDelete = []; // Clear the tracking array

                // Sync the baseline so isModified returns false
                this.originalAttachments = JSON.parse(JSON.stringify(this.attachments));
            },
            error => {
                this.errorMessage = "An error occured while attempting to save.";
                this.displaySpinner = false;
            },
            () => {
                this.displayDialog = false;
                this.getRegionalReivewSummary();
                this.getRegionalReivew();
                this.displaySpinner = false;
                this.isSaveClicked = false;
            }
        );
    }
    // save() {
    //     // Validation
    //     const hasMainFile = this.attachments && this.attachments.some(a => !a.isAttachment);
    //     const hasAttachments = this.attachments && this.attachments.some(a => a.isAttachment);
    //     const hasComment = this.reviewComment && this.reviewComment.trim().length > 0;
    //     this.isSaveClicked = true;
    //     if (!hasMainFile || !hasAttachments || !hasComment) {
    //         this.errorMessage = "File, at least one attachment, and comment are required.";
    //         return; // stop save
    //     }

    //     const formData = new FormData();
    //     formData.append('ReviewFile', this.reviewFile); //,this.reviewFile.name

    //     this._airportService.checkRegionalReviewFile(formData)
    //         .subscribe(
    //             success => {
    //                 this.displaySpinner = true;
    //                 formData.append('ScenarioId', this.User.getSession().scenarioId.toString());
    //                 formData.append('LocId', this.airport.locId);
    //                 formData.append('UserId', this.User.getSession()['id'].toString());
    //                 formData.append('CommentId', this.reviewcommentId.toString());
    //                 // if (this.review) {
    //                 //     console.log('found existing data = ' + JSON.stringify(this.review.attachments));
    //                 //     formData.append('CommentId', this.review.commentId);
    //                 // }        
    //                 formData.append('ReviewComment', this.reviewComment);
    //                 if (this.reviewAttachments) {
    //                     for (let i = 0; i < this.reviewAttachments.length; i++) {
    //                         formData.append('ReviewAttachments', this.reviewAttachments[i]); //, this.reviewAttachments[i].name
    //                     }
    //                 }

    //                 //console.log("save comment id = " + this.reviewcommentId);  

    //                 this._airportService.saveRegionalReview(formData)
    //                     .subscribe(
    //                         success => {
    //                             console.log("success");
    //                         },
    //                         error => {
    //                             this.errorMessage = "An error occured while attempting to save your comment.";
    //                             this.displayDialog = false;
    //                             this.displaySpinner = false;
    //                         },
    //                         () => {
    //                             console.log("after success");
    //                             this.displayDialog = false;
    //                             this.getRegionalReivewSummary();
    //                             this.getRegionalReivew();
    //                             this.displaySpinner = false;
    //                         }
    //                     );
    //             },
    //             error => {
    //                 this.alertDialog = "Excel is not in correct format. It must base on Quick Data Summary Report with 13 columns with 'Fiscal Year' as first column.";
    //                 this.displayAlertDialog = true;
    //             }
    //         );
    //     this.isSaveClicked = false;
    // }

    saveNotes() {
        this._airportService.updateScenarioNotes(this.airport.locId, this.User.getSession().scenarioId, this.scenarioNote)
            .subscribe(
                success => { },
                error => {
                    this.errorMessage = "An error occured while attempting to save your note.";
                    this.displayNotes = false;
                },
                () => this.displayNotes = false
            );
    }


    openPDFFile(responsepdf: any) {
        window.open(responsepdf, '_blank');
    }
    openHTMLFile(responseHtml: any) {
        window.open(responseHtml, '_blank');
    }

    onDragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isDragOver = true;
    }

    onDragLeave(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isDragOver = false;
    }

    onDropFile(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isDragOver = false;

        if (event.dataTransfer && event.dataTransfer.files.length > 0) {
            if (!this.isAllowedFile(event.dataTransfer.files[0], this.mainFileTypes)) {
                this.displayAlertDialog = true;
                this.alertDialog = "Invalid file type. Only .xls or .xlsx files are allowed for the main file.";
                return;
            }

            this.reviewFile = this.processFilesForUpload([event.dataTransfer.files[0]])[0];

            console.log(`Dropped review file: ${this.reviewFile.name}`);
            const newFileEntry = {
                file: this.reviewFile,
                fileUrl: null,
                fileName: this.reviewFile.name,
                isAttachment: false
            };

            const currentAttachments = this.attachments || [];

            // Replace main file but keep attachments
            this.attachments = [
                ...currentAttachments.filter(x => x.isAttachment),
                newFileEntry
            ];
        }
        this.resetFileInputs();
    }
    onDropAttachments(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
        this.isDragOver = false;

        if (event.dataTransfer && event.dataTransfer.files.length > 0) {
            const droppedFiles = Array.from(event.dataTransfer.files);
            const validFiles: File[] = [];
            const invalidFiles: File[] = [];
            const duplicatedFiles: File[] = []; 
            const existingNames = new Set((this.attachments || []).filter(a => a.isAttachment).map((a: { fileName: string }) => this.reverseFileName(a.fileName)));
            console.log(existingNames);
            droppedFiles.forEach(file => {
                if (!this.isAllowedFile(file, this.attachmentTypes)) {
                    invalidFiles.push(file);
                } 
                else if (existingNames.has(file.name))
                {
                    duplicatedFiles.push(file);
                }
                else {
                    validFiles.push(file);
                }
            });
            if (invalidFiles.length > 0 || duplicatedFiles.length > 0) {
                const messages: string[] = [];
                if (invalidFiles.length > 0)
                {
                    messages.push(`The following ${invalidFiles.length} file(s) have an invalid type and cannot be uploaded: ${invalidFiles.map(f => f.name).join(', ')}.\n
                                    Allowed types: ${this.attachmentTypes.join(', ')}`)
                }
                if (duplicatedFiles.length > 0)
                {
                    messages.push(`The following ${duplicatedFiles.length} file(s) are already attached and will not be uploaded again: ${duplicatedFiles.map(f => f.name).join(', ')}.\n`)
                }
                this.displayAlertDialog = true;
                this.alertDialog = messages.join('\n\n');
            }
            const processedFiles = this.processFilesForUpload(validFiles);
            this.reviewAttachments = [...(this.reviewAttachments || []), ...processedFiles];

            console.log('Dropped attachments:', this.reviewAttachments);
            console.log('Dropped processed valid:', processedFiles);

            const newAttachments = processedFiles.map(file => ({
                file: file,
                fileUrl: null,
                fileName: file.name,
                isAttachment: true
            }));
            this.attachments = [...(this.attachments || []), ...newAttachments];
            console.log('All attachments:', this.attachments);
        }
        this.resetFileInputs();
    }

    isFileFormat(file: File) {
        let iscorrect = false;

        const formData = new FormData();
        formData.append('ReviewFile', file);

        this._airportService.checkRegionalReviewFile(formData)
            .subscribe(
                success => {
                    iscorrect = true;

                },
                error => {
                    iscorrect = false;
                }
            );
        return iscorrect;
    }
    isAllowedFile(file: File, allowed: string[]): boolean {
        const name = file.name.toLowerCase();
        return allowed.some(ext => name.endsWith(ext));
    }
    currentMainFile() {
        return (this.attachments || []).find(a => !a.isAttachment) || null;
    }

    originalMainFile() {
        return (this.originalAttachments || []).find(a => !a.isAttachment) || null;
    }

    fileChanged(): boolean {
        const current = this.currentMainFile();
        // console.log("CURRENT", current);
        const original = this.originalMainFile();
        // console.log("ORIGINAL", original);

        // Case 1: user added file where none existed
        if (current && !original) return true;

        // Case 2: user removed file
        if (!current && original) return true;

        // Case 3: both exist then compare by fileName
        if (current && original) {
            return current.fileName !== original.fileName;
        }

        return false;
    }
    resetFileInputs(): void {
        if (this.reviewFileInput && this.reviewFileInput.nativeElement) {
            this.reviewFileInput.nativeElement.value = '';
        }

        if (this.reviewAttachmentsInput && this.reviewAttachmentsInput.nativeElement) {
            this.reviewAttachmentsInput.nativeElement.value = '';
        }
    }


    isModified(): boolean {
        const commentChanged = this.reviewComment !== this.originalComment;
        const currentAtt = (this.attachments || []).filter(a => a.isAttachment);
        const origAtt = (this.originalAttachments || []).filter(a => a.isAttachment);
        const sortByName = (a:any, b:any) => (a.fileName || "").localeCompare(b.fileName || "");
        const currentSorted = currentAtt.slice().sort(sortByName);
        const origSorted = origAtt.slice().sort(sortByName);
        const attachmentsChanged = JSON.stringify(currentSorted) !== JSON.stringify(origSorted);
        
        return commentChanged || attachmentsChanged || this.fileChanged();
    }
    ConfirmSubmit() {
        this.displayConfirmDialog = true;
    }

    cancelSubmit(): void {
        this.displayConfirmDialog = false;
    }

    confirmDelete(file: any) {
        this.fileToDelete = file;
        this.displayDeleteDialog = true;
    }

    deleteConfirmed() {
        if (this.fileToDelete) {
            this.displaySpinner = true;
            if (this.fileToDelete.id) {
                console.log("file to be delete id = " + this.fileToDelete.id);
                this.idsToDelete.push(this.fileToDelete.id);
                
                // var params = {
                //     id: this.fileToDelete.id,
                // };

                // this._airportService.deleteRegionalReviewFile(params)
                //     .subscribe(
                //         success => {
                //             this.originalAttachments = this.originalAttachments.filter(x => x.id !== this.fileToDelete.id);            
                //         },
                //         error => {
                //             this.errorMessage = "An error occured while attempting to delete your attachment.";
                //             this.displayDialog = false;
                //             this.displaySpinner = false;
                //         },
                //         () => {
                //             console.log("after success");
                //             this.removeAttachmentFile(this.fileToDelete);
                //             this.fileToDelete = null;

                //             // this.getRegionalReivewSummary();
                //             // this.getRegionalReivew();
                //             this.displaySpinner = false;
                //         }
                //     );
            }
            this.removeAttachmentFile(this.fileToDelete);
            this.fileToDelete = null;
            this.displaySpinner = false;
            this.displayDeleteDialog = false;

        }
        
    }

    cancelDelete() {
        this.fileToDelete = null;
        this.displayDeleteDialog = false;
    }

    closeAlertDialog() {
        this.displayAlertDialog = false;
        this.alertDialog = "";
    }

    removeAttachmentFile(item: any): void {
        this.attachments = this.attachments.filter(x => {
            let keep = true;
            if (x.fileName === item.fileName && x.isAttachment == item.isAttachment)
            {
                keep = false;
            }
            return keep;
        });
        if (!item.isAttachment) {
            this.reviewFile = null;
        }
        this.resetFileInputs();
    }
    resetCommentDialog(): void {
        this.reviewFile = null;
        this.reviewAttachments = [];
        this.isDragOver = false;
        this.displayDialog = false;
        this.isSaveClicked = false;
        // reset to original
        this.attachments = JSON.parse(JSON.stringify(this.originalAttachments));
        this.reviewComment = this.originalComment;
        this.resetFileInputs();
    }
    openConfirmDialog() {
        this.displayConfirmDialog = true;
    }
    openRevertDialog() {
        this.displayRevertDialog = true;
    }

    revertToPreliminary() {
        this.displayRevertDialog = false;
        // TODO: Implement revert logic here
    }

    get isFormValid(): boolean {
        //isFormValid() {
        const hasFile = this.attachments && this.attachments.some(a => !a.isAttachment);
        const hasAttachment = this.attachments && this.attachments.some(a => a.isAttachment);
        const hasComment = this.reviewComment && this.reviewComment.trim().length > 0 && this.reviewComment.length <= this.maxChars;
        // console.log("----------------VALIDATION CHECK----------------"); 
        // console.log("1. Has Main File? ", hasFile); 
        // console.log("2. Has Support File? ", hasAttachment); 
        // console.log("3. Has Comment? ", hasComment); 
        const ismod= this.isModified();
        // console.log("4. Is Modified? ", ismod); // Check why isModified might be false
        // if (ismod) 
        // { 
        //     console.log(" -> Comment Changed?", this.reviewComment !== this.originalComment); 
        //     console.log(" -> File Changed? ", this.fileChanged()); 
        // } 
        return !!(hasFile && hasAttachment && hasComment && ismod);
    }
    get isDraftValid(): boolean {
        const hasFile = this.attachments && this.attachments.some(a => !a.isAttachment);
        const hasAttachment = this.attachments && this.attachments.some(a => a.isAttachment);
        const hasComment = this.reviewComment && this.reviewComment.trim().length > 0 && this.reviewComment.length <= this.maxChars;

        return !!(hasFile && hasAttachment && hasComment);
    }

    //get showAttachmentRequiredBadge(): boolean {
    showAttachmentRequiredBadge() {
        return !this.viewOnly &&
            this.attachments &&
            !this.attachments.some(a => a.isAttachment);
    }

    //get showFileRequiredBadge(): boolean {
    showFileRequiredBadge() {
        return !this.viewOnly &&
            this.attachments &&
            !this.attachments.some(a => !a.isAttachment);
    }
    processFilesForUpload(files: File[]): File[] {
        return files.map(originalFile => {
            let customName = this.buildFileName(originalFile);
            const renamed = new File([originalFile], customName, { type: originalFile.type });
            return renamed
        });
    }
    buildFileName(originalFile: File): string{
        const userId = this.User.getSession()['id'].toString();
        const pad = (num: number) => ('0' + num).slice(-2);
        const now = new Date();
        // Date parts (YYYYMMDD)
        const year = now.getFullYear(); 
        const month = pad(now.getMonth() + 1); 
        const day = pad(now.getDate()); 
        
        // Time parts (HHMMSS)
        const hours = pad(now.getHours()); 
        const minutes = pad(now.getMinutes()); 
        const seconds = pad(now.getSeconds()); 
        // Combine to YYYYMMDD_HHMMSS
        const dateStr = `${year}${month}${day}_${hours}${minutes}${seconds}`;

        const lastDot = originalFile.name.lastIndexOf('.');
        const baseName = lastDot !== -1 ? originalFile.name.substring(0, lastDot) : originalFile.name;
        const ext = lastDot !== -1 ? originalFile.name.substring(lastDot) : '';
        // nameYYYYMMDD_HHMMSSuserId.ext
        return `${baseName}_${dateStr}${userId}${ext}`;

    }

    reverseFileName(name : string): string {
        return name.replace(/\d{8}_\d{6}\d+(\.[^.]*)$/,'$1');
    }
 
    openFile(item: any, event:MouseEvent): void{
        event.preventDefault();
        if (!item.file) {
            window.open(item.fileUrl,'_blank');
            return;
        }

        const blobUrl = URL.createObjectURL(item.file);
        const preview = this.isPreviewable(item.fileName);
        // DOCX, images, PDFs all work
        const a = document.createElement('a') as any;
        a.href = blobUrl;
        a.rel = 'noopener';
        if (preview)
        {
            a.target = '_blank';
        }
        else
        {
            a.download = item.fileName;
        }

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        // for cleanup
        this.blobUrls.push(blobUrl);
    }

    isPreviewable(fileName: string): boolean{
        var ext = fileName.split('.').pop()
        if (ext){
            ext = ext.toLowerCase();
        }
        return ['png','jpg','jpeg','pdf'].includes(ext || ''); 
    }


}



/** WEBPACK FOOTER **
 ** ./app/airports/regional-review.component.ts
 **/